import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=7f4ad49b&"
import script from "./StaffCard.vue?vue&type=script&lang=ts&"
export * from "./StaffCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports